export default __webpack_public_path__ + "static/media/KZ.T.05.2331 black.7c7f0868.svg";